import { filtersType } from '../../../components/v2/filters/interfaces'
import { currentFiltersProps, Enums } from './interfaces'

export const getFilters = ({
  currentFilters,
  availableFilters,
}: {
  currentFilters: currentFiltersProps
  availableFilters: Enums
}): filtersType[] => {
  const filters = [
    {
      name: 'id',
      label: 'Найти сотрудника',
      placeholder: 'ID сотрудника',
      prefix: 'ID',
      type: 'input-integer',
      value: currentFilters?.id,
      options: {
        width: '170px',
      },
    },
    {
      name: 'fio',
      label: 'ФИО',
      placeholder: 'Введите ФИО',
      type: 'input-string',
      value: currentFilters?.fio,
    },
    {
      name: 'snils',
      label: 'СНИЛС',
      placeholder: '___-___-___ __',
      type: 'input-string',
      value: currentFilters?.snils,
      options: {
        displayFormat: '000-000-000 00',
        mask: '^\\d{0,11}$',
        rules: [
          {
            validator: (_: unknown, value: string) => {
              if (value == null || value === '') return Promise.resolve()
              const digitsOnly = String(value).replace(/\D/g, '')
              if (digitsOnly.length > 0 && digitsOnly.length < 3) {
                return Promise.reject(new Error('Введите не менее 3 цифр'))
              }
              return Promise.resolve()
            },
          },
        ],
      },
    },
    {
      name: 'phone',
      label: 'Телефон',
      placeholder: 'Введите телефон',
      type: 'phone',
      value: currentFilters?.phone,
    },
    {
      name: 'post_id',
      label: 'Должность',
      placeholder: 'Выберите должность',
      type: 'select',
      value: currentFilters?.post_id,
      options: {
        enum: (availableFilters?.post || []).map(item => ({
          label: item.value,
          value: item.id,
        })),
      },
    },
    {
      name: 'department_id',
      label: 'Отдел',
      placeholder: 'Выберите отдел',
      type: 'select',
      value: currentFilters?.department_id,
      options: {
        enum: (availableFilters?.department || []).map(item => ({
          label: item.value,
          value: item.id,
        })),
      },
    },
    {
      name: 'office_id',
      label: 'Офис',
      placeholder: 'Выберите офис',
      type: 'select',
      value: currentFilters?.office_id,
      options: {
        enum: (availableFilters?.office || []).map(item => ({
          label: item.value,
          value: item.id,
        })),
      },
    },
    {
      name: 'region_id',
      label: 'Район',
      placeholder: 'Выберите район',
      type: 'select',
      value: currentFilters?.region_id,
      options: {
        enum: (availableFilters?.region || []).map(item => ({
          label: item.value,
          value: item.id,
        })),
      },
    },
    {
      name: 'company_id',
      label: 'Компания',
      placeholder: 'Выберите компанию',
      type: 'select',
      value: currentFilters?.company_id,
      options: {
        enum: (availableFilters?.company || []).map(item => ({
          label: item.value,
          value: item.id,
        })),
      },
    },
    {
      name: 'status',
      label: 'Статус',
      placeholder: 'Выберите статус',
      type: 'select',
      value: currentFilters?.status,
      options: {
        enum: [
          { label: 'Активен', value: 'active' },
          { label: 'Уволен', value: 'dismissed' },
          { label: 'Декрет', value: 'maternity' },
        ],
      },
    },
    {
      name: 'employment_date',
      label: 'Дата приема на работу',
      type: 'dates',
      options: {
        tooltip: 'Дата приема на работу',
      },
      value: currentFilters?.employment_date,
    },
    {
      name: 'dismissal_date',
      label: 'Дата увольнения',
      type: 'dates',
      options: {
        tooltip: 'Дата увольнения',
      },
      value: currentFilters?.dismissal_date,
    },
  ]

  return filters as filtersType[]
}
